// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    name: {
        title: '车辆名称',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入车辆名称'
        }]
    },
    plate: {
        title: '车牌号',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入车牌号'
        }]
    },
    role_id: {
        title: '司机',
        type: 'select',
        items: [],
        value: ''
    },
    escort_id: {
        title: '押运员',
        type: 'select',
        items: [],
        value: ''
    },
    type: {
        title: '是否默认',
        type: 'select',
        items: [{
            id: 1,
            name: '是'
        }, {
            id: 2,
            name: '否'
        }],
        value: '',
        rules: [{
            required: true,
            message: '请选择是否默认'
        }]
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '车辆名称',
    dataIndex: 'name',
    key: 'name',
    type: 'input',
    ...columnPublicConfig
},
{
    title: '车牌号',
    dataIndex: 'plate',
    key: 'plate',
    ...columnPublicConfig,
},
{
    title: '司机姓名',
    dataIndex: 'drivername',
    key: 'drivername',
    ...columnPublicConfig
},
{
    title: '押运员',
    dataIndex: 'escortname',
    key: 'escortname',
    ...columnPublicConfig
},
{
    title: '是否默认',
    dataIndex: 'type',
    filterIndex: 'type',
    key: 'type',
    type: 'select',
    items: [{
        id: 1,
        name: '是'
    }, {
        id: 2,
        name: '否'
    }],
    scopedSlots: {
        customRender: 'c-type',
        ...filterItemsConfig.scopedSlots
    },
    ...columnPublicConfig
},
{
    title: '更新时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    ...columnPublicConfig
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 180,
    scopedSlots: {
        customRender: 'c-action'
    }
}]
